import { render, staticRenderFns } from "./backTop.vue?vue&type=template&id=5c79f4ef&scoped=true"
import script from "./backTop.vue?vue&type=script&lang=js"
export * from "./backTop.vue?vue&type=script&lang=js"
import style0 from "./backTop.vue?vue&type=style&index=0&id=5c79f4ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c79f4ef",
  null
  
)

export default component.exports